<!-- <dashboardnav> -->
    <cradua-incident-tabs-in-event
    [incidentTabsInEvents]="incidentTabsInEvents$ | async"
    [eventTypes]="eventTypes$ | async"
    [incidentTabs]="incidentTabs$ | async"
    (incidentTabsInEvent)="onSubmitIncidentTabsInEvent($event)"
    (deleteIncidentTabsInEventEvent)="onDeleteIncidentTabsInEvent($event)"    
    *ngIf="
    !(isLoadingIncidentTabsInEvent$ | async ) &&
    !(isLoadingEventType$ | async ) &&
    !(isLoadingIncidentTabs$ | async )
    "
    >
  </cradua-incident-tabs-in-event>

    <mrsoftapps-epims-reference-spinner 
    *ngIf="
  (isLoadingIncidentTabsInEvent$ | async ) ||
  (isLoadingEventType$ | async ) ||
  (isLoadingIncidentTabs$ | async )
  "
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
